module.exports = __webpack_public_path__ + "img/beetle_eyes_left.33ed052d.png";